import 'dayjs/locale/th'

import dayjs from 'dayjs'
import buddhistEra from 'dayjs/plugin/buddhistEra'
import Timezone from 'dayjs/plugin/timezone'
import UTC from 'dayjs/plugin/utc'
import React, { useEffect, useState } from 'react'

import { OptionOperationTimes } from '../../components/forms/OptionOperationTimes'

dayjs.extend(buddhistEra)
dayjs.extend(UTC)
dayjs.extend(Timezone)
dayjs.locale('th')

export const AppointmentPage: React.FC = () => {
    const [startAt, setStartAt] = useState<number | null>(null)
    const [endAt, setEndAt] = useState<number | null>(null)
    const [range, setRange] = useState<number[]>([])
    const url = process.env.AGENT_WORKING_TIME_API || ''
    const defaultStartAt = 8
    const defaultEndAt = 19

    useEffect(() => {
        if (url) {
            fetch(url)
                .then((response) => response.json())
                .then((data) => {
                    setStartAt(data.StartHour)
                    setEndAt(data.EndHour)
                })
                .catch((error) => {
                    console.error('Error fetching data, falling back to defaults:', error)
                    setStartAt(defaultStartAt)
                    setEndAt(defaultEndAt)
                })
        } else {
            console.error('Error fetching data, no url')
            setStartAt(defaultStartAt)
            setEndAt(defaultEndAt)
        }
    }, [])

    useEffect(() => {
        if (startAt && endAt) {
            setRange(Array.from({ length: endAt - startAt + 1 }, (_, i) => i + startAt))
        }
    }, [startAt, endAt])

    const handleSubmit = (e: React.SyntheticEvent<HTMLFormElement>) => {
        e.preventDefault()

        const operationTimeSelect = e.currentTarget.elements.namedItem(
            'operationTime'
        ) as HTMLSelectElement
        const selectedOperationTimeRange = operationTimeSelect.value
        const today = dayjs().tz('Asia/Bangkok')

        const topupDay = today.hour() >= 0 && today.hour() < 12 ? 0 : 1

        const text = `ยืนยันนัดหมาย วันที่ ${today
            .add(topupDay, 'day')
            .format('DD MMMM BBBB')} เวลา ${selectedOperationTimeRange}`

        window.liff
            .sendMessages([
                {
                    type: 'text',
                    text,
                },
            ])
            .then(() => {
                window.liff.closeWindow()
            })
    }

    if (startAt === null || endAt === null) {
        return (
            <form onSubmit={handleSubmit} className="abcs-container pt-4 gap-y-4">
                <label className="block" htmlFor="operationTime">
                    <h5>โปรดกรอกเวลาที่ท่านสะดวกคุยกับเจ้าหน้าที่</h5>
                </label>
                <select
                    name="operationTime"
                    className="p-2 bg-white border border-gray-500 rounded w-full"
                    id="operationTime"
                >
                    <option value="" disabled selected>
                        กำลังโหลดเวลาทำการ...
                    </option>
                </select>
            </form>
        )
    }

    return (
        <form onSubmit={handleSubmit} className="abcs-container pt-4 gap-y-4">
            <label className="block" htmlFor="operationTime">
                <h5>โปรดกรอกเวลาที่ท่านสะดวกคุยกับเจ้าหน้าที่</h5>
            </label>
            <select
                name="operationTime"
                className="p-2 bg-white border border-gray-500 rounded w-full"
                id="operationTime"
            >
                <OptionOperationTimes range={range} />
            </select>
            <button type="submit" className="abcs-button fluid primary">
                รับทราบ
            </button>
        </form>
    )
}
